import { Time } from '@angular/common';
import { Timestamp } from 'rxjs/internal/operators/timestamp';

export class Appointment {
  aid: number;
  drid: number;
  patid: number;
  pat_name: string;
  dob: Date;
  apdate: Date;
  aptime: Time;
  doc_name: string;
  schedule_stat: string;
  apttype: string;
}
